function createPubSub() {
  let subscriptionIndexes = [];
  const listeners = /* @__PURE__ */ new Set();
  const narrowListeners = /* @__PURE__ */ new Map();
  function listen(eventTypeOrListener, singleListener) {
    if (typeof eventTypeOrListener === "string") {
      if (singleListener !== void 0) {
        narrowListeners.set(eventTypeOrListener, narrowListeners.get(eventTypeOrListener) ?? /* @__PURE__ */ new Set());
        narrowListeners.get(eventTypeOrListener)?.add(singleListener);
        subscriptionIndexes.push(singleListener);
        return () => {
          const index = subscriptionIndexes.indexOf(singleListener);
          subscriptionIndexes.splice(index, 1);
          return !!narrowListeners.get(eventTypeOrListener)?.delete(singleListener);
        };
      }
      throw new Error(`[createPubSub] You must provide a callback function for the event ${eventTypeOrListener}.`);
    }
    if (typeof eventTypeOrListener === "function") {
      listeners.add(eventTypeOrListener);
      subscriptionIndexes.push(eventTypeOrListener);
      return () => {
        const index = subscriptionIndexes.indexOf(eventTypeOrListener);
        subscriptionIndexes.splice(index, 1);
        return listeners.delete(eventTypeOrListener);
      };
    }
    throw new Error(`[createPubSub] You must provide a callback function.`);
  }
  function removeAllListeners() {
    listeners.clear();
    narrowListeners.clear();
    subscriptionIndexes = [];
  }
  function notify(action) {
    const actionType = action.type;
    const listenersByActionType = narrowListeners.get(actionType) ?? [];
    const sortedTargets = [...listeners, ...listenersByActionType].sort((a, b) => {
      const aIndex = subscriptionIndexes.indexOf(a);
      const bIndex = subscriptionIndexes.indexOf(b);
      return aIndex - bIndex;
    });
    sortedTargets.forEach((listener) => {
      listener(action, actionType);
    });
  }
  return {
    listen,
    notify,
    removeAllListeners
  };
}
export {
  createPubSub
};
//# sourceMappingURL=pubSub.js.map
